import React from 'react';
import ReactGA from 'react-ga';
import { Routes, Route } from "react-router-dom";
import Header from './components/header/header';
import HomeV2 from './pages/home/homeV2';
import Resume from './pages/resume/resume';
import CampusDive from './pages/portfolio/cd/cdCaseStudy';
import NBNB from './pages/portfolio/NBNB/nbnb';
import Mha from './pages/portfolio/mha/mha';
import ConditionsCaseStudy from './pages/portfolio/conditionsCaseStudy/conditionsCaseStudy';
import PortfolioPage from './pages/portfolioPage/portfolioPage.js';
import Footer from './components/footer/footer';
import './App.css';
import AboutPage from './pages/about/about.js';

function App() {
  ReactGA.initialize('G-NRZW311QGL');

  // const resume = document.getElementById("resume");
  // console.log('reume?', resume)
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<HomeV2 />}/>    
        <Route path="portfolio" element={<PortfolioPage />}/>
        <Route path="about" element={<AboutPage />}/>
        <Route path="resume" element={<Resume />} />
        <Route path="NBNB" element={<NBNB />} />
        <Route path="CampusDive" element={<CampusDive />} />
        <Route path="MHA" element={<Mha />} />
        <Route path="disability-claims" element={<ConditionsCaseStudy />} />
        {/* <Route path="4ALL" element={<ForAll />} /> */}
      </Routes>
      <Footer />
    </> 
  );
}

export default App;
